import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BadgeIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M18.67,11.31a2.34,2.34,0,0,1,0-2.76h0a2.34,2.34,0,0,0-2.14-3.71h0a2.34,2.34,0,0,1-2.39-1.38h0a2.34,2.34,0,0,0-4.28,0h0A2.34,2.34,0,0,1,7.47,4.84h0A2.34,2.34,0,0,0,5.33,8.55h0a2.34,2.34,0,0,1,0,2.76h0A2.34,2.34,0,0,0,7.47,15h0A2.34,2.34,0,0,1,9.86,16.4h0a2.34,2.34,0,0,0,4.28,0h0A2.34,2.34,0,0,1,16.53,15h0a2.34,2.34,0,0,0,2.14-3.71ZM12,13.5a3.57,3.57,0,1,1,3.56-3.57A3.57,3.57,0,0,1,12,13.5Z"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "12",
    cy: "9.93",
    r: "2.67"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9,16.76a1.43,1.43,0,0,0-1.32-.86H7.56a2.17,2.17,0,0,1-.36,0,3.39,3.39,0,0,1-.64-.07l-2,3.47a.44.44,0,0,0,0,.49.45.45,0,0,0,.47.16l2.61-.7.7,2.61a.45.45,0,0,0,.38.33H8.8A.44.44,0,0,0,9.19,22l2-3.42A3.19,3.19,0,0,1,9,16.76Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17.44,15.85a3.39,3.39,0,0,1-.64.07,2.17,2.17,0,0,1-.36,0h-.16a1.43,1.43,0,0,0-1.32.86,3.19,3.19,0,0,1-2.12,1.81l2,3.42a.44.44,0,0,0,.39.22h.05a.45.45,0,0,0,.38-.33l.7-2.61,2.61.7a.45.45,0,0,0,.47-.16.44.44,0,0,0,0-.49Z"
  })]
}), 'BadgeIcon');